(() => {
  if (window.cervoCampaignLoaded) return;
  window.cervoCampaignLoaded = true;
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-cervo-campaign]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const deadline = Date.parse(root.dataset.deadline);
      const delay = Number(root.dataset.delay) || 6000;
      const banner = root.querySelector('[data-campaign-banner]');
      const dialog = root.querySelector('dialog');
      const key = `cervo:campaign:${root.dataset.campaign}`;
      let timer, arrival, previousFocus, jump = false;
      const close = () => { if (dialog?.open) dialog.close(); };
      const tick = () => {
        const seconds = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
        if (!Number.isFinite(deadline) || seconds <= 0) {
          banner.hidden = true;
          close();
          clearInterval(timer);
          clearTimeout(arrival);
          return false;
        }
        banner.hidden = false;
        const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
        const units = [root.dataset.days, root.dataset.hours, root.dataset.minutes, root.dataset.seconds];
        const text = values.map((v, i) => `${String(v).padStart(2, '0')}${units[i]}`).join(' : ');
        root.querySelectorAll('[data-campaign-countdown]').forEach(node => { node.textContent = text; });
        return true;
      };
      if (!tick()) return;
      timer = setInterval(tick, 1000);
      const date = root.querySelector('[data-campaign-date]');
      if (date) date.textContent = `${new Intl.DateTimeFormat('en-US', {timeZone: 'America/New_York', month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short'}).format(deadline)}`;
      if (dialog) {
        dialog.querySelectorAll('[data-campaign-jump]').forEach(button => button.addEventListener('click', () => { jump = true; }));
        dialog.querySelectorAll('[data-campaign-close]').forEach(button => button.addEventListener('click', close));
        dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); } });
        dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('cervo-sale-open');
          const offer = document.getElementById('offer');
          if (jump && offer) {
            jump = false;
            offer.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center'});
            offer.querySelector('[data-buy]')?.focus({preventScroll: true});
          } else {
            previousFocus?.focus({preventScroll: true});
          }
        });
        let seen = false;
        try { seen = localStorage.getItem(key) === 'seen'; } catch (_) { seen = true; }
        if (!seen && !window.Shopify?.designMode) arrival = setTimeout(() => {
          if (!tick()) return;
          try { if (localStorage.getItem(key) === 'seen') return; localStorage.setItem(key, 'seen'); } catch (_) { return; }
          previousFocus = document.activeElement;
          dialog.showModal();
          document.documentElement.classList.add('cervo-sale-open');
        }, delay);
      }
      root.addEventListener('cervo:cleanup', () => { clearInterval(timer); clearTimeout(arrival); close(); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-cervo-campaign]').forEach(root => root.dispatchEvent(new Event('cervo:cleanup'))));
})();
